import { AvailLine } from './availibility.model';
import { Annulation } from './annulation.model';
import { PrePaiement } from './pre-paiement.model';
import { NoShow } from './no-show.model';
import { ICombineEngine } from '@app/shared';
import { has, minBy, chunk, cloneDeep, sortBy, values, some } from 'lodash';

export class Line {
    id: number;
    isDispo: boolean;
    stock: number;
    occupation: string;
    indexSearch: string;
    adults: number;
    enfants: number;
    categorie: number;
    offre_site: Array<any>;
    conditiondetail: any;
    price: number;
    garantie: boolean;
    service: Array<any>;
    taxe: {
        'new': { Ttc: number; Sale: number; HT: number; TaxeExc: number; TaxeInc: number; Taxes?: any },
        old: { Ttc: number; Sale: number; HT: number; TaxeExc: number; TaxeInc: number; Taxes?: any },
    }
    engines: Array<any> = [];
    PrePaiement: PrePaiement;
    noShow: NoShow;
    annulation: Annulation;
    engineSelected: ICombineEngine = null;
    constructor() {

    };

    public bindingData(data: AvailLine) {
        this.id = data.id;
        this.isDispo = data.isDispo;
        this.stock = data.stock;
        this.setOccupation(data.occupation);
        this.categorie = data.categorie;
        this.indexSearch = data.indexSearch;
        //        this.offre_site = [{id: 78, status: true, minsjour: 5, img: "1435141913_sparaccourci.jpg"}, {id: 77, status: false, minsjour: 7, img: "1435141913_sparaccourci.jpg"}, {id: 72, status: false, minsjour: 2, img: "1435141913_sparaccourci.jpg"}, {id: 10, status: true, minsjour: 2, img: "1435141913_sparaccourci.jpg"}];
        this.offre_site = values(data.offre_site);
        this.conditiondetail = data.conditiondetail;
        this.price = data.price;
        this.garantie = data.garantie;
        this.taxe = data.taxe;
        let detailprePaiement = new PrePaiement();
        this.PrePaiement = detailprePaiement.bindingData(data.conditiondetail)
        let deailNs = new NoShow();
        this.noShow = deailNs.bindingData(data.conditiondetail)
        let deailAn = new Annulation();
        this.annulation = deailAn.bindingData(data.conditiondetail);
        if (data.isDispo) {
            this.addEngine({ combine: data.toCombine(), alias: "w" });
            this.updateMinEngine();
        }
    }

    public setOccupation(occupation: string): Line {
        this.occupation = occupation;
        this.adults = parseInt(occupation.split('_')[0]);
        this.enfants = parseInt(occupation.split('_')[1]);
        return this;
    }

    public setIndexSearch(indexSearch: string): Line {
        //        let s = indexSearch.split('_');
        //        let adults = parseInt(s[0]);
        //        let enfants = parseInt(s[1]);
        //        let index = parseInt(s[2])/*+ 1*/;
        //        this.indexSearch = ''.concat(adults.toString(), '_', enfants.toString(), '_', index.toString());
        this.indexSearch = indexSearch;
        return this;
    }

    /**
     * get garantie (is cart required)
     * @returns boolean
     */
    public getGarantie(): boolean {
        return this.getRealGarantie(this.engineSelected, this.garantie);
    }

    public getRealGarantie(engineSelected: ICombineEngine, defaultGarantie: boolean): boolean {
        if (engineSelected.combine.garantie != undefined) {
            return engineSelected.combine.garantie;
        } else {
            console.log(" 'getRealGarantie' Engine add Garantie:boolean");
        }
        return defaultGarantie;
    }

    /**
     * get min engine by ttc
     * @returns ICombineEngine
     */
    public getMinEngine() {
        return minBy(this.engines, (engine: ICombineEngine) => engine.combine.ttc);
    }

    /**
     * update min engine by TTC
     * @returns Line
     */
    public updateMinEngine() {
        this.engineSelected = this.getMinEngine();
        //Fix bug line.indexSearch != engineSelected.combine.indexSearch
        this.setIndexSearch(this.engineSelected.combine.indexSearch);
        return this;
    }

    /**
     * add engine from comparator
     * @param ICombineEngine     engine
     * @returns Line
     */
    public addEngine(engine: ICombineEngine) {
        if (engine.combine.priceByAdult == undefined) {
            engine.combine.priceByAdult = {};
        }
        engine.combine.priceByAdult[this.adults] = {
            detailPrice: engine.combine.detailPrice,
            detailPrice_without_promo: engine.combine.detailPrice_without_promo,
        }
        let detailprePaiement = new PrePaiement();
        engine.combine.PrePaiement = detailprePaiement.bindingData(engine.combine.conditiondetail)
        let deailNs = new NoShow();
        engine.combine.noShow = deailNs.bindingData(engine.combine.conditiondetail)
        let deailAn = new Annulation();
        engine.combine.annulation = deailAn.bindingData(engine.combine.conditiondetail);

        this.engines.push(engine);
        this.engines = sortBy(this.engines, [(o: ICombineEngine) => o.combine.ttc])
        //let selet = this.getBestprice();
        return this;
    }

    /**
     * engine exists
     * @param alias string alias OTA
     * @returns boolean
     */
    public hasEngine(alias: string): boolean {
        return some(this.engines, ['alias', alias]);
    }
    public clearEngine(): Line {
        this.engines = [];
        this.engineSelected = null;
        return this;
    }

    /**
     * best engine
     */
    public getBestprice() {
        //TODO: select bestprice from engines
        return null
    }


    /**
     * clone objecy
     * @returns Line
     */
    public clone(): Line {
        //        let data = cloneDeep(this)
        //        return data;
        let data = JSON.parse(JSON.stringify(this))
            , ln = new Line();
        data.isDispo = false;
        ln.bindingData(new AvailLine(data));
        return ln;
    }

    /**
     * actver la line
     * @returns Line
     */
    public enabled() {
        this.isDispo = true;
        return this;
    }

    /**
     * titre lignetarifaire
     * @param id string id service
     * @returns string
     */
    public getTitelLigneTarifaire(id: string): string {
        return 'lignetarifaire.' + id + '-titer';
    }

    /**
     * titre service
     * @param id string id service
     * @returns string
     */
    public getTitelService(id: string): string {
        return 'service.' + id + '-titer';
    }

    /**
     * titre LigneTarifier ex : {{line.getTitelLine()|translate}}
     * @returns string
     */
    public getTitelLine(): string {
        return 'lignetarifiercategorie.' + this.categorie + '-titer';
    }
    /**
     *
     *
     */
    public getOfferts(display: number = 3): any {
        return chunk(this.offre_site, display);
    }


}